import Select from "../../../components/Form/Select";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_STYLE,
  TEMPLATES_TEXT_STYLE_ITALIC,
  TEMPLATES_TEXT_STYLE_ITALIC_UNDERLINE,
  TEMPLATES_TEXT_STYLE_NORMAL,
  TEMPLATES_TEXT_STYLE_UNDERLINE,
} from "../../../i18n/keysTranslations";
import { TEXT_STYLE } from "../utils/textStyle";

const optionalRules = { required: false };

const TextStyleSelect = ({
  control,
  errors,
  disabled,
  onChangeField,
  name = "textStyle",
  label,
}) => {
  const { t } = useTranslationApp();
  return (
    <Select
      control={control}
      errors={errors}
      name={name}
      label={label || t(TEMPLATES_STYLE)}
      variant="filled"
      fullWidth
      disabled={disabled}
      rules={optionalRules}
      actionsChange={(value) => onChangeField({ key: "textStyle", value })}
      options={[
        { value: TEXT_STYLE.NORMAL, label: t(TEMPLATES_TEXT_STYLE_NORMAL) },
        { value: TEXT_STYLE.ITALIC, label: t(TEMPLATES_TEXT_STYLE_ITALIC) },
        {
          value: TEXT_STYLE.UNDERLINE,
          label: t(TEMPLATES_TEXT_STYLE_UNDERLINE),
        },
        {
          value: TEXT_STYLE.ITALIC_UNDERLINE,
          label: t(TEMPLATES_TEXT_STYLE_ITALIC_UNDERLINE),
        },
      ]}
    />
  );
};

export default TextStyleSelect;
